import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  checkAccess: () => boolean; // Function to determine if access is allowed
  fallbackPath: string; // Path to navigate if access is denied
  children: ReactNode; // The content to render if access is allowed
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ checkAccess, fallbackPath, children }) => {
  return checkAccess() ? <>{children}</> : <Navigate to={fallbackPath} />;
};

export default ProtectedRoute;
